export { default, type TooltipProps } from './Tooltip';
